import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('pagination', { itemPage: 'items' }),
    pagination() {
      return this.itemPage.find(item => item.name === this.$route.name);
    }
  },
  watch: {
    'options.page'(value) {
      localStorage.setItem('prevpage', value);
      this.$store.commit('pagination/SET_PREV_PAGE', {
        name: this.$route.name,
        path: this.$route.fullPath,
        prevpage: value
      });
      this.getData();
    },
    'options.itemsPerPage'(value) {
      localStorage.setItem('prevPerPage', value);
      this.$store.commit('pagination/SET_PREV_PERPAGE', {
        name: this.$route.name,
        path: this.$route.fullPath,
        prevPerPage: value
      });
      this.getData();
    }
  },
  mounted() {
    this.options.page = (this.pagination || {}).prevpage;
    // this.options.page = this.pagination.prevpage;
    this.options.itemsPerPage = this.pagination.prevPerPage;
  },
  methods: {}
};
